import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { AddTemplate } from 'components/Dashboards/Portfolio/phasePerformance/manage/components/addTemplate';
import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';

export const PhasePerformanceManageAddTemplatePage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.phasePerformanceManageAddTemplate.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader
                        pageTitle={portfolioConfig.phasePerformanceManageAddTemplate.title}
                        showBack={true}
                    />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <AddTemplate />
            </MainContent>
        </PageContainer>
    );
};
